<template>
  <CustomDialog v-model="dialog" ref="customDialog" hideHeader hideFooter>
    <v-window v-model="step">
      <v-window-item :value="1">
        <section v-if="raffle">
          <div class="text-h6">
            O sorteio #{{ raffle?.code }} foi finalizado
          </div>
          <div class="text-body-2 neutral8--text mb-4">
            Confira abaixo o resultado da apuração do concurso
          </div>

          <RaffleCard class="mb-2" :raffle="raffle || {}" :hide-footer="true" />

          <ResultRaffleCard
            class="mb-4"
            :raffle="raffle || {}"
            :ranking="ranking || {}"
            :loadingRanking="loadingRanking"
            detailed
          />

          <div class="d-flex justify-center align-center">
            <v-btn class="btn" color="primary" @click="nextStep()">
              Avançar <v-icon right>mdi-chevron-right</v-icon>
            </v-btn>
          </div>
        </section>

        <div v-else class="d-flex align-center flex-column flex-sm-row">
          <v-progress-circular
            class="mb-6 mb-sm-0 mr-sm-6"
            color="primary"
            size="64"
            indeterminate
          />

          <div class="d-flex flex-column">
            <div class="text-h6">Estamos apurando o sorteio!</div>

            <div class="text-body-1">
              Aguarde um momento, o resultado sai em instantes!
            </div>
          </div>
        </div>
      </v-window-item>

      <v-window-item :value="2">
        <section
          v-if="newRaffle?.status === 'open' || raffle?.status === 'open'"
        >
          <div class="text-h5 font-weight-bold mb-2">
            🎉 Palavra do dia liberada!
          </div>

          <v-card class="card pa-4 mb-2" color="neutral1" outlined>
            <div class="text-subtitle-1 mb-1">
              <v-icon>mdi-circle-small</v-icon>

              O sorteio
              <span class="font-weight-bold primary--text">
                #{{ newRaffle.code || raffle.code }}
              </span>
              já começou!
            </div>

            <div class="text-subtitle-1">
              <v-icon>mdi-circle-small</v-icon>

              🏆 Prêmio em jogo:
              <span class="font-weight-bold primary--text">
                R$
                {{
                  currencyMask(newRaffle?.awards?.cash || raffle?.awards?.cash)
                }}
              </span>
            </div>
          </v-card>

          <div class="text-body-1 font-weight-bold mb-6">
            Jogue agora, acumule bilhetes e aumente suas chances de ganhar!
          </div>

          <div class="d-flex justify-center align-center">
            <v-btn
              v-if="raffle?.status === 'finished'"
              class="btn font-weight-black mr-4"
              color="white"
              outlined
              rounded
              plain
              text
              @click="backStep()"
            >
              <v-icon> mdi-arrow-left </v-icon>
            </v-btn>

            <v-btn
              class="btn font-weight-bold"
              color="primary"
              rounded
              @click="close()"
            >
              Começar a jogar 🚀
            </v-btn>
          </div>
        </section>

        <section v-else class="d-flex align-center">
          <div class="d-flex align-center flex-column flex-sm-row">
            <v-progress-circular
              class="mb-6 mb-sm-0 mr-sm-6"
              color="primary"
              size="64"
              indeterminate
            />

            <div class="d-flex flex-column">
              <div class="text-h6">Preparando os novos desafios...</div>

              <div class="text-body-2 neutral8--text">
                Aguarde até que tudo esteja pronto para jogar e participar! 😉
              </div>
            </div>
          </div>
        </section>
      </v-window-item>
    </v-window>
  </CustomDialog>
</template>

<script>
import { mapGetters } from "vuex";
import { currencyMask } from "@/helpers";
import CustomDialog from "@/components/customDialog/CustomDialog";
import RaffleCard from "@/components/raffleCard/RaffleCard";
import ResultRaffleCard from "@/components/resultRaffleCard/ResultRaffleCard";

export default {
  name: "RaffleStatusDialog",

  components: {
    CustomDialog,
    RaffleCard,
    ResultRaffleCard,
  },

  data() {
    return {
      dialog: false,
      loadingRanking: true,
      step: 1,
      raffle: null,
      newRaffle: null,
      ranking: null,
    };
  },

  computed: {
    ...mapGetters({ _currentRaffle: "currentRaffle" }),
  },

  watch: {
    _currentRaffle: {
      handler(val) {
        if (val && this.dialog) this.newRaffle = val;
      },
      deep: true,
    },
  },

  methods: {
    open(raffle, ranking) {
      if (this.dialog) return;

      this.step = raffle.status === "finished" ? 1 : 2;
      this.raffle = raffle;
      this.dialog = true;

      if (ranking) this.setRanking(ranking);
    },

    setRanking(ranking) {
      if (!ranking) return;

      this.ranking = ranking;
      this.loadingRanking = false;
    },

    close() {
      this.$root.$emit("refresh:current-raffle");

      const gameRoutes = ["Games", "Hangman", "LuckyPath", "PrizeWord"];

      if (this.$route.name === "Home") location.reload();

      if (gameRoutes.includes(this.$route.name)) {
        this.$router.push(
          { name: "Home" },
          () => {},
          () => {}
        );
      }

      this.dialog = false;
      this.loadingRanking = true;
    },

    backStep() {
      this.step--;
    },

    nextStep() {
      this.step++;
    },

    currencyMask,
  },
};
</script>

<style src="./style.scss" lang="scss" scoped />
